/* Бургер и выдвижная панель меню. Модуль не привязан к ширине экрана: на
   планировщике бургер живёт только под мобильным порогом (см. Toolbar), а на
   странице поездок он и есть вся навигация, на любом экране. */

.burger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Палец, а не курсор: сторона кнопки — не меньше рекомендованных 44px. */
  width: max(44px, var(--ctl-h));
  height: max(44px, var(--ctl-h));
  flex: none;
  padding: 0;
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  color: var(--text);
  cursor: pointer;
}

.burger:hover {
  background: var(--surface-2);
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  background: var(--overlay);
}

/* Панель выезжает от левого края — оттуда же, где стоит сама кнопка. */
.sheet {
  display: flex;
  flex-direction: column;
  width: min(88vw, 360px);
  height: 100%;
  background: var(--surface);
  border-right: var(--bw) solid var(--border);
  box-shadow: var(--shadow-modal);
}

.sheet:focus {
  outline: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  flex: none;
  padding: var(--sp-5) var(--sp-5);
  border-bottom: 1px solid var(--border);
}

.title {
  font-size: var(--fs-lg);
  font-weight: 600;
}

.closeBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: none;
  background: transparent;
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-lg);
  cursor: pointer;
}

.closeBtn:hover {
  background: var(--surface-2);
  color: var(--text);
}

/* Снизу воздуха больше, чем сверху, и он считается вместе с системной полосой
   жестов: последний пункт списка — «Выйти» — иначе упирается в самый край
   экрана и выглядит приклеенным к нему, а на телефонах с домашней полосой ещё
   и попадает под неё. */
.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--sp-5);
  padding-bottom: calc(var(--sp-7) + env(safe-area-inset-bottom, 0px));
}

/* ── Секции ───────────────────────────────────────────────────────────────
   Разделы отбиты друг от друга воздухом и волоском: заголовок раздела уже
   говорит, что началось новое, рамка вокруг каждого была бы шумом. */

.section + .section {
  margin-top: var(--sp-6);
  padding-top: var(--sp-6);
  border-top: 1px solid var(--border);
}

.legend {
  margin: 0 0 var(--sp-3);
  color: var(--text-3);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

/* Контролы в меню — под палец: рекомендованные 44px минимум, а не высота
   строки тулбара, рассчитанная на курсор. Обводка при этом мягче, чем в
   полосе: в столбик из десятка кнопок сильная рамка складывается в частокол,
   а разделять их и так есть чему — волоску между строками. */
.rows :global(.btn),
.rows :global(.select),
.rows :global(.input) {
  min-height: 48px;
  border-color: var(--border);
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
  min-height: 44px;
  padding: var(--sp-2) 0;
}

/* Разделитель между строками, но не после последней: раздел заканчивается
   волоском своей секции, второй под ним смотрелся бы двойным. */
.row:not(:last-child) {
  border-bottom: 1px solid var(--border);
}

/* Строка, у которой контрол ничего не нарисовал, прячется целиком.
   Экран кладёт сюда готовый элемент и не знает, вернёт ли тот что-нибудь:
   поле названия поездки, например, у гостя честно рендерит null — и строка
   оставалась подписью над пустотой, будто контрол не загрузился. */
.row:not(:has(> .rowLabel ~ *)) {
  display: none;
}

.rowLabel {
  min-width: 0;
  color: var(--text-2);
  font-size: var(--fs-md);
}

/* Блок во всю ширину: кнопка перехода, форма, панель персонализации. */
.block {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  padding: var(--sp-2) 0;
}

.block > :global(.btn) {
  width: 100%;
  min-height: 48px;
  justify-content: center;
}

/* Ссылка в роли кнопки: без сброса она приходит подчёркнутой и в цвете
   ссылок, и в ряду обычных кнопок читается как чужая. */
.block > :global(a.btn) {
  color: inherit;
  text-decoration: none;
}
